import React, { createContext, useContext, useReducer, useEffect } from 'react';

const CartContext = createContext(null);
const STORAGE_KEY = 'bakari_cart_v1';

const load = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) ?? { items: [] }; }
  catch { return { items: [] }; }
};

function reducer(state, action) {
  switch (action.type) {
    case 'ADD': return { items: [...state.items, ...action.items] };
    case 'REMOVE': return { items: state.items.filter(i => i.cartId !== action.cartId) };
    case 'CLEAR': return { items: [] };
    default: return state;
  }
}

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, undefined, load);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }, [state]);

  return (
    <CartContext.Provider value={{
      items: state.items,
      addItems: (items) => dispatch({ type: 'ADD', items }),
      removeItem: (cartId) => dispatch({ type: 'REMOVE', cartId }),
      clearCart: () => dispatch({ type: 'CLEAR' }),
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart requires CartProvider');
  return ctx;
};
